export default "__VITE_ASSET__38bfb7f4__"